var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","overflow":"hidden"},attrs:{"headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }